/*
 * @Author: cn1994
 * @Date: 2023-01-17 18:26:49
 * @LastEditors: cn1994
 * @LastEditTime: 2023-02-03 10:20:25
 * @Description: 登陆的表单验证规则
 */

// 用户名验证规则
const checkUsername = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入账号'))
  }
  if (value.replace(/(^\s*)|(\s*$)/g, "").indexOf(' ') > -1) {
    return callback(new Error('账号格式错误'))
  }
  return callback();
}

// 密码验证规则
const checkPwd = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  if (value.indexOf(' ') > -1) {
    return callback(new Error('密码格式错误'))
  }
  if (!/^[a-zA-Z0-9_@]{0,20}$/.test(value)) {
    return callback(new Error('密码只能允许输入包括字母，数字，@和下划线在内的1到20位字符'))
  }
  return callback();
}

// 图形验证码验证规则
const checkCerifyCode = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入验证码'))
  }
  return callback();
}

// 手机号验证规则
const checkMobile = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入手机号'))
  }
  if (!/^1\d{10}$/.test(value)) {
    return callback(new Error('手机号格式不正确'))
  }
  return callback();
}

// 验证码验证规则
const checkSMSCode = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入验证码'))
  }
  return callback();
}

export default {
  checkUsername,
  checkPwd,
  checkCerifyCode,
  checkMobile,
  checkSMSCode
}